module.exports = __webpack_public_path__ + "static/img/WechatIMG115.1dcfb95.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/WechatIMG115.png
// module id = 9wg1
// module chunks = 1